<template>
  <b-container fluid class="position-relative" style="min-height: 100vh">
    <div v-if="isRefVisible" @click="closeRefs" class="close-ref"></div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(sendToFts)" autocomplete="off">
        <b-tabs v-model="tabIndex" id="document-tabs" content-class="mt-3">
          <b-tab :active="i.active" v-for="i in tabs" :key="i.key">
           <template #title>
             {{ i.name }}
             <b-button-close 
               @click="removeDoc(i.name)" 
               class="ml-3"
               v-if="!notForEdit && (i.name === 'Паспорт РФ' || i.name === 'Индивидуальная накладная' || i.name === 'Графические материалы')"></b-button-close>
           </template>
            <ecr-page
              v-if="i.name === 'ПТД для экспресс-грузов'"
              ref="ecrPage"
              :ecr="ecr"
              :notForEdit="notForEdit"
              @updateEcr="savePackageInIdb()"
              :getValidationState="getValidationState"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </ecr-page>
            <goods-page
              v-if="i.name === 'Товарные партии'"
              ref="goodsPage"
              :ecr="ecr"
              :notForEdit="notForEdit"
              @updateEcr="savePackageInIdb()"
              @updateTotals="updateTotals()"
              :getValidationState="getValidationState">
            </goods-page>
            <passport-page v-if="i.name === 'Паспорт РФ'"
              ref="passportPage"
              :passport="passport"
              :notForEdit="notForEdit"
              @updateInventory="savePackageInIdb()"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeDoc(i.name)"
              @setTabIndex="tabIndex = tabs.length-1"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </passport-page>
            <waybill-page v-if="i.name === 'Индивидуальная накладная'"
              ref="waybillPage"
              :waybill="waybill"
              :notForEdit="notForEdit"
              @updateWaybill="savePackageInIdb()"
              @updateHsFields="updateHsFields($event)"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeWaybillPage()"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setTabIndex="tabIndex = tabs.length-1"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </waybill-page>
            <inventory-page v-if="i.name === 'Графические материалы'"
              ref="inventoryPage"
              :notForEdit="notForEdit"
              :freeBinaryDocs="freeBinaryDocs"
              parentType="ecr"
              @updateDocs="savePackageInIdb()"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeInventoryPage()"
              @setTabIndex="tabIndex = tabs.length-1"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </inventory-page>
          </b-tab>
          <template #tabs-end>
            <b-nav-item-dropdown 
              v-if="!notForEdit && !hasTab('Графические материалы')" 
              text="+ Добавить документ" 
              no-caret 
              toggle-class="border border-white rounded-0 bg-white">
               <b-dropdown-item 
                  v-if="hasTab('Паспорт РФ')" 
                  @click.prevent="addPassportPage">
                Паспорт РФ
               </b-dropdown-item>
               <b-dropdown-item 
                 v-if="hasTab('Индивидуальная накладная')" 
                 @click.prevent="addWaybillPage">
                Индивидуальная накладная
               </b-dropdown-item>
               <b-dropdown-item 
                 v-if="!hasTab('Графические материалы')" 
                 @click.prevent="addInventoryPage">
                Графические материалы
               </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
        </b-tabs>
        <b-row class="mb-3 mt-7">
          <b-col xl="6" lg="12" md="12" sm="12" cols="12">
            <div class="d-md-flex d-lg-flex align-items-center">
              <span v-b-tooltip.hover
                    :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="sendToPortal"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="hasEmptyRequiredFields || notForEdit"
                  squared size="sm"
                >
                  Сохранить
                </b-button>
              </span>
              <span v-b-tooltip.hover :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="scrollIfError"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="notForEdit"
                  squared
                  size="sm"
                >
                Отправить&nbsp;в&nbsp;ФТС
              </b-button>
              </span>
              <div v-if="hasEmptyRequiredFields" class="mr-3 custom-invalid-feedback" style="height: 31px">
                Заполните обязательные поля на вкладках ПТД для экспресс-грузов, Товарные партии
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal ref="save-package-result-modal" @hidden="hideModal" hide-footer no-close-on-backdrop no-close-on-esc
             title="Данные успешно сохранены">
      <div class="d-block text-center">
        <span>Создан РЭГ №{{ $route.params.pid }}</span>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="checkoutToEditEcr">Продолжить работу
        с РЭГ
      </b-button>
      <b-button class="mt-2" variant="outline-success" block @click="() => $router.push('/ecr')">Перейти к
        списку РЭГ
      </b-button>
    </b-modal>
    <b-modal ref="get-packages-from-cache" hide-footer no-close-on-backdrop no-close-on-esc
             title="У вас есть несохраненные данные">
      <b-button class="mt-2" variant="primary" @click="$refs['get-packages-from-cache'].hide()" block>Отмена</b-button>
      <b-button class="mt-2" variant="outline-danger" @click="deletePackageFromIdb" block>Уйти с потерей данных
      </b-button>
    </b-modal>
  </b-container>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import EcrPage from './EcrPage'
  import GoodsPage from './EcrGoodsPage'
  import idbapi from '../../../idbapi/idb.js'
  import moment from 'moment'
  import PassportPage from './PassportPage'
  import WaybillPage from './WaybillExpressIndividualPage'
  import InventoryPage from './InventoryPage'

  export default {
    name: "EcrForm",
    components: {
      EcrPage,
      GoodsPage,
      PassportPage,
      WaybillPage,
      InventoryPage
    },
    data () {
      return {
        CustomsCode: null,
        TotalGrossWeightQuantity: null,
        TotalCurrencyQuantity: null,
        TotalCustomsCost: null,
        BrokerName: null,
        BrokerDocRegNumberId: null,
        SignatoryPersonSurname: null,
        SignatoryPersonName: null,
        SignatoryDate: null,
        ConsignorName: null,
        ConsigneeName: null,
        showAllDeclineReasons: false,
        tabIndex: 0,
        tabs: [
          { name: 'ПТД для экспресс-грузов', key: Math.random() },
          { name: 'Товарные партии', key: Math.random() }
        ],
        showConfirmModal: false,
        notForEdit: false,
        idbPackageId: 1,
        preventedRouteTo: null,
        targetInput: null,
        isRefVisible: false,
        docsLoading: false
      }
    },
    watch: {
      '$route' (val, oldVal) {
        if (val.name === 'AddEcr') {
          this.$nextTick(() => {
            this.$refs.ecrPage[0].resetFormData()
            this.$refs.goodsPage[0].resetFormData()
            if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
              this.$refs.waybillPage[0].resetFormData()
            }
            if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
              this.$refs.inventoryPage[0].resetFormData()
            }
          })
          this.setPackagePid(null)
          this.setPackageChainid(null)
          this.setPackageStatus(null)
          this.setPackageDocumentsList(null)
          this.setWaybill(null)
          this.setFreeBinaryDocs(null)
          this.notForEdit = false
        }
        if (val.name === 'EditEcr' && oldVal.name !== 'EditEcr' && oldVal.name !== 'AddEcr') {
          this.getPackageDocumentsList(val.params.pid).then(
            () => {
              if (this.isNewPackageInChain()) {
                this.setPackagePid({ pid: null })
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      },
    },
    beforeRouteLeave (to, from, next) {
      this.preventedRouteTo = to.name
      if ((to.meta.prevented === false) || ((from.name === 'EditEcr') && (to.name !== 'Login'))) {
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              next(false)
              this.$refs['get-packages-from-cache'].show()
            } else {
              next()
            }
          }
        )
      } else {
        next()
      }
    },
    mounted () {
      if (this.$route.name === 'AddEcr') {
        this.setPackageDocumentsList(null)
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              if (documents[0].waybill) {
                this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
              }
              if (documents[0].freeBinaryDocs) {
                this.tabs.push({ name: 'Графические материалы', key: Math.random() })
              }
              setTimeout(() => {
                this.addPackageDataFromIdb(documents)
              }, 0)
            }
          }
        )
      }
      this.$nextTick(() => {
        this.$refs.ecrPage[0].resetFormData()
        this.$refs.goodsPage[0].resetFormData()
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          this.$refs.waybillPage[0].resetFormData()
        }
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          this.$refs.inventoryPage[0].resetFormData()
        }
        this.$refs.observer.reset()
      })
      if (this.$route.name === 'EditEcr') {
        this.getPackageDocumentsList(this.$route.params.pid).then(
          () => {
            if (!this.isEditedAsNewPackage()) {
              this.notForEdit = this.isPackageNotForEdit()
            }
            if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
              this.setPackagePid(null)
            }
            if (this.isEditedAsNewPackage()) {
              this.setPackageChainid(null)
              this.setPackageStatus(null)
            }
            idbapi.getPackageData().then(
              (documents) => {
                if (documents && (documents.length > 0)) {
                  if (documents[0].waybill) {
                    this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
                  }    
                  if (documents[0].freeBinaryDocs) {
                    this.tabs.push({ name: 'Графические материалы', key: Math.random() })
                  }
                  setTimeout(() => {
                    this.addPackageDataFromIdb(documents)
                  }, 200)
                } else {
                  this.getDocuments()
                }
              }
            )
          },
          (error) => {
            console.log(error)
          }
        )
      }
      if (this.$route.params.hsIds) {
        this.$refs.goodsPage[0].loadData()
      }
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.CustomsCode
        },
        (val) => {
          this.CustomsCode = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.TotalGrossWeightQuantity
        },
        (val) => {
          this.TotalGrossWeightQuantity = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.TotalCurrencyQuantity
        },
        (val) => {
          this.TotalCurrencyQuantity = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.TotalCustomsCost
        },
        (val) => {
          this.TotalCustomsCost = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Consignor_Name
        },
        (val) => {
          this.ConsignorName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Consignee_Name
        },
        (val) => {
          this.ConsigneeName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Broker_Name
        },
        (val) => {
          this.BrokerName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Broker_DocRegNumberId
        },
        (val) => {
          this.BrokerDocRegNumberId = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Signatory_PersonSurname
        },
        (val) => {
          this.SignatoryPersonSurname = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Signatory_PersonName
        },
        (val) => {
          this.SignatoryPersonName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.ecrPage[0].ecrForm.Signatory_Date
        },
        (val) => {
          this.SignatoryDate = val
        }
      )
    },
    computed: {
      ...mapState(
        {
          ecr: state => state.ecr.package,
          waybill: state => state.houseShipment.waybill,
          freeBinaryDocs: state => state.houseShipment.freeBinaryDocs,
          packagePid: state => state.ecr.packagePid,
          packageChainid: state => state.ecr.packageChainid,
          packageStatus: state => state.ecr.packageStatus,
          nsiCountries: state => state.commissionShipment.nsiCountries,
          packageDocumentsList: state => state.ecr.packageDocumentsList,
          package: state => state.houseShipment.package,
          userInfo: state => state.authorization.userInfo
        }
      ),
      hasEmptyRequiredFields(){
        if (!this.CustomsCode || 
            !this.TotalGrossWeightQuantity ||
            !this.TotalCurrencyQuantity ||
            !this.ConsigneeName ||
            !this.ConsignorName ||
            !this.TotalCustomsCost) return true
        else return false
      },
    },
    methods: {
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      closeRefs () {
        for (const item in this.$refs.ecrPage[0].ecrForm) {
          if (this.$refs.ecrPage[0].$refs[item] && this.$refs.ecrPage[0].$refs[item].items) {
            this.$refs.ecrPage[0].$refs[item].items = []
          }
        }
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          for (const item in this.$refs.waybillPage[0].waybillForm) {
            if (this.$refs.waybillPage[0].$refs[item] && this.$refs.waybillPage[0].$refs[item].items) {
                this.$refs.waybillPage[0].$refs[item].items = []
            }
          }
        }
      },
      addPassportPage () {
        this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
      },
      addWaybillPage () {
        this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
      },
      addInventoryPage () {
        this.tabs.push({ name: 'Графические материалы', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
          this.$refs.inventoryPage[0].inventoryForm.data.push(
              {
                key: Math.random(),
                file: null,
                FileName: 'Файл не выбран',
                did: null,
                DOC_ID: null,
                ModeCode: '09023', // Код документа
                DocName: null, // Наименование документа
                RegNum: null, // Номер документа
                RegDate: null, // Дата документа
                FileData: null,
              }
            )
        }, 200)
      },
      removeDoc (docName) {
        switch (docName) {
          case 'Паспорт РФ':
            this.removePassportPage()
            break
          case 'Индивидуальная накладная':
            this.removeWaybillPage()
            break
          case 'Графические материалы':
            this.removeInventoryPage()
            break
        }
      },
      removeWaybillPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Индивидуальная накладная'), 1)
        setTimeout(() => {
          this.tabIndex = 1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          if (this.$refs.waybillPage[0].waybillForm.did) {
            this.deleteWaybill({
              pid: this.$route.params.pid,
              did: this.$refs.waybillPage[0].waybillForm.did
            }).then(
              () => {
                this.$refs.waybillPage[0].resetFormData()
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      removeInventoryPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Графические материалы'), 1)
        setTimeout(() => {
          this.tabIndex = 1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          this.$refs.inventoryPage[0].inventoryForm.data.forEach(doc => {
            if (doc.did) this.deleteFreeBinaryDoc({ pid: this.$route.params.pid, did: doc.did })
          })
          this.$refs.inventoryPage[0].resetFormData()
        }
      },
      removePassportPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Паспорт РФ'), 1)
        setTimeout(() => {
          this.tabIndex = 1
          this.savePackageInIdb()
        }, 200)
      },
      hasTab (itemName) {
        return this.tabs.some(e => e.name === itemName)
      },
      hasTabName (tabName) {
        const hasTabName = this.tabs.find((item) => {
          return item.name === tabName
        })
        return !!hasTabName
      },
      isPackageNotForEdit () {
         let notForEdit = [4, 731].find((item) => {
           return item === parseInt(this.packageStatus)
         })
        return notForEdit === undefined
      },
      isEditedAsNewPackage () {
        return (this.$route.query.new === 'true')
      },
      isNewPackageInChain () {
        const isNewPackageInChain = [4, 731].find((item) => {
          return item === parseInt(this.packageStatus)
        })
        return !!isNewPackageInChain
      },
      scrollIfError () {
        this.$refs.observer.validate()
        setTimeout(() => {
          const fieldsWithErrors = this.$refs.observer.errors
          let fieldsNames = []
          for (const property in fieldsWithErrors) {
            if (fieldsWithErrors[property].length > 0) {
              fieldsNames.push(property)
            }
          }
          if (fieldsNames.length > 0) {
            fieldsNames = fieldsNames.join(', ')
            this.$bvToast.toast('Заполните: ' + fieldsNames + '!', {
              title: 'Не заполнено обязательное поле',
              toaster: 'b-toaster-bottom-right',
              solid: true,
              appendToast: true,
              noAutoHide: true
            })
          } else {
            this.sendToFts()
          }
        }, 500)
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      sendToPortal () {
        this.showConfirmModal = true
        this.savePackage()
      },
      sendToFts () {
        this.savePackage().then(
          () => {
            this.sendPackageFts(this.$route.params.pid).then(
              () => {
                this.$router.push('/ecr')
              },
              error => {
                console.log(error)
              }
            )
          },
          error => {
            console.log(error)
          }
        )
      },
      getPackagePid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return parseInt(this.$route.params.pid)
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      getPackageChanid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return this.packageChainid
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditEcr') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      addPackageDataFromIdb (documents) {
        this.idbPackageId = documents[0].id
        this.setPackage({
          data: {
            data: documents[0].ecr,
            did: documents[0].ecr.did
          }
        })
        if (documents[0].waybill !== null) {
          this.setWaybill({ data: { data: documents[0].waybill, did: documents[0].waybill.did } })
        }
        if (documents[0].freeBinaryDocs !== null) {
          this.setFreeBinaryDocs(documents[0].freeBinaryDocs)
        }
      },
      deletePackageFromIdb () {
        idbapi.deletePackageData(this.idbPackageId)
        this.$refs['get-packages-from-cache'].hide()
        this.$router.push({ name: this.preventedRouteTo })
      },
      savePackageInIdb () {
        const ecrData = Object.assign(
          {},
          this.$refs.ecrPage[0].ecrForm,
          { PKGHOUSESHIPMENT: this.$refs.goodsPage[0].PKGHOUSESHIPMENT }
        )
        let waybillData = null
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          waybillData = this.$refs.waybillPage[0].waybillForm
        }
        let docsData = null
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
            docsData = this.$refs.inventoryPage[0].inventoryForm.data
        }
        idbapi.updatePackageData({
          id: this.idbPackageId,
          ecr: ecrData,
          waybill: waybillData,
          freeBinaryDocs: docsData,
          pid: (this.$route.params.pid) ? (this.$route.params.pid) : null,
          editedAsNew: this.isEditedAsNewPackage(),
          new: (this.$route.name === 'AddEcr'),
          edited: (this.$route.name === 'EditEcr'),
          type: 'ecr'
        })
      },
      savePackage () {
        return new Promise((resolve, reject) => {
        this.$refs.ecrPage[0].ecrForm.ExpressRegistryKindCode = 'ПТДЭГ'
        const payload = Object.assign(
          {},
          this.$refs.ecrPage[0].ecrForm,
          { PKGHOUSESHIPMENT: this.$refs.goodsPage[0].PKGHOUSESHIPMENT },
        )
        let waybillData = null
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          waybillData = this.$refs.waybillPage[0].waybillForm
        }
        let docsData = null
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
            docsData = this.$refs.inventoryPage[0].inventoryForm.data
        }
        this.saveEcr(payload).then(
          () => {
            if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
              this.saveWaybill(waybillData).then(
                () => {
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
            }
            if (docsData) {
              this.saveFreeBinaryDocList(docsData).then(
                () => {
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
            }
            if (this.showConfirmModal) this.$refs['save-package-result-modal'].show()
            resolve()
          },
          (error) => {
            reject(error)
          }
        )
        idbapi.deletePackageData(this.idbPackageId)
        })
      },
      saveEcr (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.ecrPage[0].ecrForm.did === null) {
            this.createEcr({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data
            }).then(
              (result) => {
                this.$refs.ecrPage[0].ecrForm.did = result.did
                if ((this.$route.name === 'AddEcr') || ((this.$route.name === 'EditEcr') && this.isNewPackageInChain()) || ((this.$route.name === 'EditEcr') && this.isEditedAsNewPackage())) {
                  this.$router.push(`/ecr/${this.packagePid}`)
                }
                resolve()
              },
              error => {
                reject(error)
              }
            )
          } else {
            this.editEcr({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data
            }).then(
              () => {
                resolve()
              },
              error => {
                reject(error)
              }
            )
          }
        })
      },
      saveWaybill (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.waybillPage[0].waybillForm.did === null) {
            this.createWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                (result) => {
                  this.$refs.waybillPage[0].waybillForm.did = result.did
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
          } else {
            this.editWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                () => {
                  resolve()
                },
                error => {
                  reject(error)
                }
              )
            }
        })
      },
      async saveFreeBinaryDocList (data) {
        for (let i = 0; i < data.length; i++) {
          const freeBinaryDocData = {
            pid: this.getPackagePid(),
            chainid: this.getPackageChanid(),
            did: null,
            data: data[i]
          }
          if (data[i].did) {
            freeBinaryDocData.did = data[i].did
            await this.editFreeBinaryDoc(freeBinaryDocData)
          } else {
            await this.createFreeBinaryDoc(freeBinaryDocData).then(
              (result) => {
                data[i].did = result.did
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      hideModal () {
        this.showConfirmModal = false
        if (this.$route.name !== 'EditEcr') {
          this.$router.push(`/edit/${this.packagePid}`)
        }
        if (this.$route.name === 'EditEcr') {
          this.getPackageDocumentsList(this.$route.params.pid).then(
            () => {
              if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
                this.setPackagePid(null)
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
      },
      checkoutToEditEcr () {
        this.$refs['save-package-result-modal'].hide()
      },
      async getDocuments () {
        function compare (a, b) {
          if (a.type < b.type) return -1
          if (a.type > b.type) return 1
          return 0
        }
        this.packageDocumentsList.sort(compare)
        for (let i = 0; i < this.packageDocumentsList.length; i++) {
          switch (this.packageDocumentsList[i].type.toLowerCase()) {
            case 'expresscargodeclarationptd.cfg.xml':
              await this.getPackageByPid({
                 pid: this.$route.params.pid,
                 new: this.isEditedAsNewPackage()
               })
              break
            case 'wbei.cfg.xml':
              if (!this.hasTabName('Индивидуальная накладная')) {
                this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
              }
              await this.getWaybillByPid({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
            case 'passportrf.cfg.xml':
              if (!this.hasTabName('Паспорт РФ')) {
                // this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
              }
              // await this.getWaybillByPid({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
            case 'freebinarydoc.cfg.xml':
              if (!this.hasTabName('Графические материалы')) {
                this.tabs.push({ name: 'Графические материалы', key: Math.random() })
              }
              await this.getFreeBinaryDoc({
                pid: this.$route.params.pid,
                did: this.packageDocumentsList[i].did,
                new: this.isEditedAsNewPackage()
              })
              break
          }
        }
      },
      updateTotals () {
         this.$refs.ecrPage[0].ecrForm.TotalGrossWeightQuantity = this.$refs.goodsPage[0].PKGHOUSESHIPMENT.PKGHOUSESHIPMENT_ITEM.reduce((sum, current) => {
          return sum + (((current.GrossWeightQuantity === null) || (current.GrossWeightQuantity === '')) ? 0 : parseFloat(current.GrossWeightQuantity))
        }, 0)
         this.$refs.ecrPage[0].ecrForm.TotalCurrencyQuantity = this.$refs.goodsPage[0].PKGHOUSESHIPMENT.PKGHOUSESHIPMENT_ITEM.reduce((sum, current) => {
          return sum + (((current.CurrencyQuantity === null) || (current.CurrencyQuantity === '')) ? 0 : parseFloat(current.CurrencyQuantity))
        }, 0)
        this.$refs.ecrPage[0].ecrForm.TotalCustomsCost = this.$refs.goodsPage[0].PKGHOUSESHIPMENT.PKGHOUSESHIPMENT_ITEM.reduce((sum, current) => {
          return sum + (((current.CustomsCost === null) || (current.CustomsCost === '')) ? 0 : parseFloat(current.CustomsCost))
        }, 0)
        this.$refs.ecrPage[0].$refs['TotalCurrencyCode'].model = this.$refs.ecrPage[0].ecrForm.TotalCurrencyCode =
          this.$refs.ecrPage[0].$refs['TotalCustomsCurrencyCode'].model = this.$refs.ecrPage[0].ecrForm.TotalCustomsCurrencyCode = 643
        this.$refs.ecrPage[0].$refs['TotalCurrencyCodeABR'].model = this.$refs.ecrPage[0].ecrForm.TotalCurrencyCodeABR =
          this.$refs.ecrPage[0].$refs['TotalCustomsCurrencyCodeABR'].model = this.$refs.ecrPage[0].ecrForm.TotalCustomsCurrencyCodeABR = 'RUB'

        this.$nextTick(() => {
          this.savePackageInIdb()
        })
      },
      ...mapActions({
        createEcr: 'ecr/createEcr',
        editEcr: 'ecr/editEcr',
        getPackageByPid: 'ecr/getEcrByPid',
        sendPackageFts: 'ecr/sendPackageFts',
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        getPackageDocumentsList: 'ecr/getPackageDocumentsList',
        getWaybillByPid: 'houseShipment/getWaybillByPid',
        createWaybill: 'houseShipment/createWaybill',
        editWaybill: 'houseShipment/editWaybill',
        deleteWaybill: 'houseShipment/deleteWaybill',
        getFreeBinaryDoc: 'houseShipment/getFreeBinaryDoc',
        deleteFreeBinaryDoc: 'houseShipment/deleteFreeBinaryDoc',
        createFreeBinaryDoc: 'houseShipment/createFreeBinaryDoc',
        editFreeBinaryDoc: 'houseShipment/editFreeBinaryDoc',
      }),
      ...mapMutations({
        setPackage: 'ecr/setPackage',
        setPackagePid: 'ecr/setPackagePid',
        setPackageChainid: 'ecr/setPackageChainid',
        setPackageStatus: 'ecr/setPackageStatus',
        setNsiCountries: 'commissionShipment/setNsiCountries',
        setPackageDocumentsList: 'ecr/setPackageDocumentsList',
        setWaybill: 'houseShipment/setWaybill',
        setFreeBinaryDocs: 'houseShipment/setFreeBinaryDocs',
      }),
    },
    beforeDestroy () {
      this.setPackage(null)
      this.setPackagePid(null)
      this.setPackageChainid(null)
      this.setPackageStatus(null)
      this.setPackageDocumentsList(null)
      this.setWaybill(null)
      this.setFreeBinaryDocs(null)
      this.notForEdit = false
    }
  }
</script>

<style lang="scss" scoped>
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }

  .close-ref {
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: transparent;
    /* background-color: #989fa4; */
  }
</style>
